import React, {useContext, useState} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, Select, TreeSelect} from "antd"
import UserContext from "../../context/UserContext"

UserView.propTypes = {
    label: PropTypes.string,
    item: PropTypes.object
}

function UserView(props) {
    const {label, item} = props
    const {treeData, roles} = useContext(UserContext)

    const [isModalVisible, setIsModalVisible] = useState(false)

    const showModal = () => {
        setIsModalVisible(true)
    }

    const handleCancel = () => {
        setIsModalVisible(false)
    }

    return (
        <div className="CustomerForm">
            <span className="CustomLink" onClick={showModal}>
                {item.userName}
            </span>
            <Modal
                title={label}
                className="ModalCustom"
                centered
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel}>
                        Cancel
                    </Button>
                ]}
            >
                <div className="FormEdit">
                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="name">
                                Username
                            </label>
                            <input type="text" value={item.userName} disabled/>
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="name">
                                Tên người dùng
                                <span className="Required">*</span>
                            </label>
                            <input type="text" value={item.fullName} disabled/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="name">
                                Phòng ban
                            </label>
                            <TreeSelect
                                style={{width: '100%'}}
                                value={item.deptId}
                                disabled
                                dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                treeData={treeData}
                                placeholder="Please select"
                                treeDefaultExpandAll
                            />
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="name">
                                Trạng thái
                            </label>
                            <Select value={item.status} disabled>
                                <Select.Option value={1}>Active</Select.Option>
                                <Select.Option value={0}>Disable</Select.Option>
                            </Select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="FormField col-md-12">
                            <label className="Label" htmlFor="name">
                                Danh sách quyền
                            </label>
                            <Select
                                className="SelectMulti"
                                mode="multiple"
                                allowClear
                                style={{width: '100%'}}
                                placeholder="Please select"
                                defaultValue={!!item.roles && item.roles.length > 0 && item.roles.map(item => item.roleId)}
                                disabled
                            >
                                {
                                    !!roles && roles.length > 0 && roles.map(item => {
                                        return <Select.Option key={item.roleId}
                                                              value={item.roleId}>{item.roleName}</Select.Option>
                                    })
                                }
                            </Select>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default UserView